import ContactHero from "../components/ContactHero"
import ContactContent from "../components/ContactContent"
const Contact = () => {
    return (
        <section>
            <ContactHero/>
            <ContactContent/>
        </section>
    )
}
export default Contact